import PhoneNumberForm from '@features/games/profile/phone-number/phone-number-form/phone-number-form';
export default PhoneNumberForm;
